import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'excludeStderr' })
export class ExcludeStderrPipe implements PipeTransform {
  transform(array: any[]): any[] {
    return array?.filter((item) => item.result_type !== 'stderr') ?? [];
  }
}
